import { Component, OnInit, ViewChild } from '@angular/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';

import * as dayjs from 'dayjs';
import { HourglassService } from 'src/app/services/hourglass.service';

@Component({
  selector: 'app-tab-calendar',
  templateUrl: './tab-calendar.component.html',
  styleUrls: ['./tab-calendar.component.css']
})
export class TabCalendarComponent implements OnInit {
  token!: string;
  csharpEvents: any[] = [];
  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;
  calendarOptions: any = {
    plugins: [dayGridPlugin, timeGridPlugin],
    initialView: 'timeGridWeek',
    scrollTime: '07:00:00',
    firstDay: 0,
    headerToolbar: {
      left: '',
      center: 'title',
      right: ''
    },
    height: '100vh',
    nowIndicator: true,
    editable: false,
    slotLabelFormat: { hour: '2-digit', minute: '2-digit', hour12: true },
    dayHeaderFormat: { weekday: 'short', month: 'numeric', day: 'numeric' },
    events: [],
    eventDidMount: (info: any) => {
      const eventEl = info.el;
      const source = info.event.extendedProps?.source;
      eventEl.classList.remove('csharp-event');
      if (source === 'csharp') {
        eventEl.classList.add('csharp-event');
      }
    },
    datesSet: (dateInfo: any) => {
      const start = dayjs(dateInfo.start).format('YYYY-MM-DD');
      const end = dayjs(dateInfo.end).format('YYYY-MM-DD');
      //this.loadCSharpEvents(start, end);
    }
  };

  constructor(
    private hourglassService: HourglassService
  ) {}

  ngOnInit() {
    const user: any = sessionStorage.getItem("wOSUser");
    this.token = JSON.parse(user).stsTokenManager.accessToken;
    //this.loadCSharpEvents();
  }

  getEventsSync(): void {
    this.loadCSharpEvents();
  }

  loadCSharpEvents(startDate?: string, endDate?: string) {
    const userId = sessionStorage.getItem('wOSAuthUser') || '';
    if (!userId) return;
  
    const filters = {
      from_entries: startDate || dayjs().subtract(90, 'days').format('YYYY-MM-DD'),
      thru_entries: endDate || dayjs().add(14, 'days').format('YYYY-MM-DD')
    };
  
    this.hourglassService.getTimeEntryUxData(userId, 'all', filters,this.token).then(data => {
      const entries = Array.isArray(data) ? data : data?.entries || [];
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
      this.csharpEvents = entries.map((entry: any, index: number) => {
        const title = entry.t_name || entry.task_name || 'Untitled';
        const start = entry.t_start;
        const end = entry.t_end;
  
        if (!start || !end) {
          console.warn(`Skipping C# entry with missing times`, entry);
          return null;
        }
  
        const parsedStart = dayjs.utc(start).tz(timezone);
        const parsedEnd = dayjs.utc(end).tz(timezone);
  
        if (!parsedStart.isValid() || !parsedEnd.isValid()) {
          console.warn(`Invalid dayjs parse at index ${index}`, { start, end });
          return null;
        }
  
        return {
          id: `csharp-${index}`,
          title,
          start: parsedStart.toDate(),
          end: parsedEnd.toDate(),
          allDay: false,
          extendedProps: { source: 'csharp' }
        };
      }).filter((e: any) => e !== null);
  
      this.updateCalendarEvents();
    });
  }

  updateCalendarEvents() {
    const allEvents = [...this.csharpEvents];

    if (this.calendarComponent && this.calendarComponent.getApi()) {
      const calendarApi = this.calendarComponent.getApi();
      calendarApi.removeAllEvents();
      allEvents.forEach(event => calendarApi.addEvent(event));
      calendarApi.render();
    } else {
      this.calendarOptions.events = allEvents;
    }
  }

  formatTimeWithTimezone(date: string, time: string): string {
    const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const rawDateTime = `${date}T${this.formatTime(time)}`;
    return dayjs.utc(rawDateTime).tz(localTz).format();
  }

  private formatTime(raw: any): string {
    const time = String(raw);
    if (time.includes(':')) return time;
    const num = Number(raw);
    if (!isNaN(num)) {
      const hrs = Math.floor(num / 100);
      const mins = num % 100;
      return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:00`;
    }
    return '09:00:00';
  }
}
